import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    isLogin: Boolean(localStorage.getItem('isLogin')) || false
  },
  getters: {
    isLogin: state => state.isLogin
  },
  mutations: {
    loginState (state, flag) {
      if (flag === 'true') {
        localStorage.setItem('isLogin', 'true')
        state.isLogin = true
      } else {
        localStorage.removeItem('isLogin')
        state.isLogin = false
      }
    }
  },
  actions: {
    setLogin ({commit}, flag) {
      commit('loginState', flag)
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js